export default "__VITE_ASSET__2b7ecba6__"